import { VariableGroup } from '../enum/variable-card.enum';
import { VariableValue } from './variable-value.model';

export class Allowance extends VariableValue {
  public variableGroup: VariableGroup = VariableGroup.ALLOWANCE;
  constructor(allowance: Partial<Allowance>) {
    super();
    Object.assign(this, allowance);
  }
}
